import type { ReactNode } from 'react'
import s from './FilterBar.module.scss'

/**
 * Die Zeile über einer Liste.
 *
 * Nur Anordnung, kein Zustand: Welche Filter es gibt und was sie tun, weiß die
 * Seite. Diese Komponente weiß, dass Filter auf dem Handy untereinander stehen
 * und ab Tablet nebeneinander.
 */
export function FilterBar({ children }: { children: ReactNode }) {
  return <div className={s.bar}>{children}</div>
}

/** Nimmt den restlichen Platz — für das Suchfeld. */
export function FilterGrow({ children }: { children: ReactNode }) {
  return <div className={s.grow}>{children}</div>
}

/** Feste, schmale Breite — für Auswahlfelder. */
export function FilterFixed({ children }: { children: ReactNode }) {
  return <div className={s.fixed}>{children}</div>
}

/** Rutscht ab Tablet nach rechts — für Anzahl und Zurücksetzen. */
export function FilterEnd({ children }: { children: ReactNode }) {
  return <div className={s.end}>{children}</div>
}

/** Die Trefferzahl neben den Filtern. */
export function FilterCount({ children }: { children: ReactNode }) {
  return <span className={s.count}>{children}</span>
}
